// extracted by mini-css-extract-plugin
export default {"options":"ProductsView_options__SWy2Y"};